import { api } from "#/lib/api-client";
import type { Notice, NoticeApprovalRequest, NoticeRequest, PageResponse } from "./types";

const BASE = "/api/notices";

export const noticesApi = {
  // ── Everyone — dashboard Notice Board widget ────────────────────────────
  active(): Promise<Notice[]> {
    return api.get<Notice[]>(`${BASE}/active`).then((r) => r.data);
  },

  // ── Admin (Organisation > Notices) ──────────────────────────────────────
  list(page = 0, size = 20, status?: string): Promise<PageResponse<Notice>> {
    return api.get<PageResponse<Notice>>(BASE, { params: { page, size, status } }).then((r) => r.data);
  },

  create(payload: NoticeRequest): Promise<Notice> {
    return api.post<Notice>(BASE, payload).then((r) => r.data);
  },

  update(id: number, payload: NoticeRequest): Promise<Notice> {
    return api.put<Notice>(`${BASE}/${id}`, payload).then((r) => r.data);
  },

  remove(id: number): Promise<void> {
    return api.delete(`${BASE}/${id}`).then(() => undefined);
  },

  approve(id: number, remarks?: string | null): Promise<Notice> {
    return api.post<Notice>(`${BASE}/${id}/approve`, { remarks } as NoticeApprovalRequest).then((r) => r.data);
  },

  reject(id: number, remarks?: string | null): Promise<Notice> {
    return api.post<Notice>(`${BASE}/${id}/reject`, { remarks } as NoticeApprovalRequest).then((r) => r.data);
  },

  // ── Everyone — personal pin / reminder on a specific notice ─────────────
  pin(id: number): Promise<void> {
    return api.post(`${BASE}/${id}/pin`).then(() => undefined);
  },

  unpin(id: number): Promise<void> {
    return api.delete(`${BASE}/${id}/pin`).then(() => undefined);
  },

  requestReminder(id: number): Promise<void> {
    return api.post(`${BASE}/${id}/reminder`).then(() => undefined);
  },

  cancelReminder(id: number): Promise<void> {
    return api.delete(`${BASE}/${id}/reminder`).then(() => undefined);
  },
};
